import React from 'react';
import PropTypes from 'prop-types';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import DocumentTemplateForm from './document_template_form';

import { createStore } from 'redux';
import thunk from 'redux-thunk';
import { applyMiddleware } from 'helpers/redux_dev_tools';
import rootReducer from './store/root_reducer';
import { Provider } from 'react-redux';
import { nanoid } from 'nanoid';
import PageTemplateForm from './page_template_form';
import { PageEditUrlsContext } from './page_picker/page_edit_urls_context';

export default function DocumentDefaults({
  basePath,
  cancelPath,
  companyId,
  companyName,
  corporateScope,
  pageEditUrls,
  tagSuggestions,
  teamsEnabled,
  template,
  defaults,
  parentCompanyDefaults,
  parentCompanyName
}) {
  const { allAvailablePages } = template;
  const defaultPages = defaults.defaultPages ? defaults.defaultPages.map(page => ({
    ...page,
    key: nanoid()
  })) : null;

  const availablePageTemplateTreeIds = (defaults.availablePageTemplateTreeIds || []).map(page => ({
    ...page,
    key: nanoid()
  }));

  const formData = { ...defaults, defaultPages, availablePageTemplateTreeIds };

  const store = createStore(rootReducer, { formData, availablePages: allAvailablePages }, applyMiddleware(thunk));

  const RedirectWithQueryParams = (values) => {
    // Extract the search (query string) from props.location
    const queryParams = values.location.search;

    return <Redirect to={`/edit${queryParams}`} />;
  };

  return (
    <Provider store={store}>
      <PageEditUrlsContext.Provider value={pageEditUrls ?? null}>
        <Router basename={basePath}>
          <Switch>
            <Route exact path="/edit">
              <DocumentTemplateForm
                afterSavePath={cancelPath}
                basePath={basePath}
                companyId={companyId}
                companyName={companyName}
                corporateScope={corporateScope}
                initialFormData={formData}
                parentCompanyDefaults={parentCompanyDefaults}
                parentCompanyName={parentCompanyName}
                tagSuggestions={tagSuggestions}
                teamsEnabled={teamsEnabled}
                template={template}
              />
            </Route>
            <Route path="/pages/:id" strict>
              <PageTemplateForm
                basePath={basePath}
                documentTemplateId={template.id}
                documentTemplateName={template.name}
                templateType="Docs::PageTemplateTree"
              />
            </Route>
            <Route path="/user_pages/:id" strict>
              <PageTemplateForm
                basePath={basePath}
                documentTemplateId={template.id}
                documentTemplateName={template.name}
                templateType="Docs::UserPageTemplate"
              />
            </Route>
            <Route path="/pdf_pages/:id" strict>
              <PageTemplateForm
                basePath={basePath}
                documentTemplateId={template.id}
                documentTemplateName={template.name}
                templateType="Docs::PdfPageTemplate"
              />
            </Route>
            <Route exact path="/" render={values => <RedirectWithQueryParams {...values} />} />
          </Switch>
        </Router>
      </PageEditUrlsContext.Provider>
    </Provider>
  );
}

DocumentDefaults.propTypes = {
  basePath: PropTypes.string.isRequired,
  cancelPath: PropTypes.string.isRequired,
  companyId: PropTypes.number,
  companyName: PropTypes.string.isRequired,
  corporateScope: PropTypes.object,
  defaults: PropTypes.object.isRequired,
  pageEditUrls: PropTypes.objectOf(PropTypes.string),
  parentCompanyDefaults: PropTypes.object,
  parentCompanyName: PropTypes.string,
  tagSuggestions: PropTypes.arrayOf(PropTypes.string),
  teamsEnabled: PropTypes.bool,
  template: PropTypes.object.isRequired
};
